import { AbstractGoMoveGenerator } from '../AbstractGoMoveGenerator';
import { HexagonalGoRules } from './HexagonalGoRules';
export class HexagonalGoMoveGenerator extends AbstractGoMoveGenerator {
    constructor() {
        super(HexagonalGoRules.get());
    }
}
